/**
 * holidayPack — 連休パック（LP の5日間・CDW/NOC込みの定額。2026-10-09〜。年末年始は 3日・4日パックもあり、json_data の holiday_pack_tier に日数）
 *
 * LP が json_data.data に holiday_pack='1' / holiday_pack_days=<パックに含めた日数> /
 * holiday_pack_price=<円> を入れて保存する。この予約は base_price にパック価格（CDW/NOC込み）＋超過分を含み、
 * noc_price / cdw_price はパック超過日数分だけ。
 *   - Square 請求書: 「連休パック 車種名（N日間・CDW/NOC込）」の1行（square_create_invoice.php）
 *   - AI エージェントの料金変更: 自動再計算は未対応（補償の日額が「insurance ÷ 日数」で出せないため）
 * 正: booking-platform/md/pricing.md「連休パック」
 */
import { extractJsonDataRecord } from './hotelDelivery';

export const HOLIDAY_PACK_KEY = 'holiday_pack';

export function isHolidayPackReservation(jsonData: unknown): boolean {
  const data = extractJsonDataRecord(jsonData);
  const flag = data ? String(data[HOLIDAY_PACK_KEY] ?? '').trim() : '';
  return flag === '1' || flag.toLowerCase() === 'true';
}
